import { useQuery } from "@tanstack/react-query";
import { getPlanningSettings } from "@/api/settings";
import {
  routeLimitsFromSettings,
  type ConfiguredRouteLimits,
} from "@/features/routes/lib/unassignedBreakdown";

/**
 * The route limits the tenant's planning settings actually configure (BUG-685),
 * or `null` while they load or when the fetch failed.
 *
 * Shares the `["settings-planning"]` cache with the Planning settings tab and
 * `useTenantTimezone`, so it adds no request of its own in a warm session and
 * never blocks rendering: callers word the `undetermined` advice neutrally until
 * the settings arrive.
 */
export function useConfiguredRouteLimits(): ConfiguredRouteLimits | null {
  const { data } = useQuery({
    queryKey: ["settings-planning"],
    queryFn: getPlanningSettings,
    staleTime: 5 * 60_000,
  });
  return routeLimitsFromSettings(data);
}
